import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { GET_USER_QUERY } from 'clientState/providers/operations/getUser';
import { GetUserQueryQuery } from 'generated/graphql';

export const useGetUserQuery = (): UseQueryResult<GetUserQueryQuery> => {
  return useQuery(GET_USER_QUERY, {});
};

export default useGetUserQuery;
